<template>
  <div>
    <el-dialog title="课程内容信息" :visible.sync="chapterListDialog" width="60%">
      <div class="whiteBg">
        <el-button type="primary" plain icon="el-icon-plus" @click="chapterInfoDialogOpen()">添加单元</el-button>
        <dy-table ref="chapterTable" tableHeight="300" style="margin-top: 12px;" :columns="chapterListColumns"
          :table-data="chapterList" v-loading="chapterListLoading" :isShowPager="false" element-loading-text="加载中"
          rowKeyName="uKey" dragClassName="drag-class">
        </dy-table>
      </div>
      <div class="box box-align-center box-pack-end mt-btns" style="margin-top: 12px; margin-right: 30px;">
        <el-button type="primary" plain @click="chapterListSave()">保存</el-button>
        <el-button type="danger" plain @click="() => chapterListDialog = false">取消</el-button>
      </div>
    </el-dialog>

    <el-dialog title="单元信息" :visible.sync="chapterInfoDialog" width="60%" :close-on-click-modal="false">
      <el-form ref="chapterInfoForm" v-if="chapterInfoDialog" label-position="right" label-width="60px" :model="chapter"
        :rules="infoRules">
        <el-form-item label="单元名称：" prop="chapterName" required>
          <el-input style="width: 500px;" v-model="chapter.chapterName" placeholder="请输入单元名称"></el-input>
        </el-form-item>
      </el-form>
      <div class="box box-align-center box-pack-end mt-btns" style="margin-top: 12px; margin-right: 30px;">
        <el-button type="primary" plain @click="chapterInfoSave()">保存</el-button>
        <el-button type="danger" plain @click="() => chapterInfoDialog = false">取消</el-button>
      </div>
    </el-dialog>

    <el-dialog title="单元内容" :visible.sync="chapterDialog" width="80%" :close-on-click-modal="false">
      <div>
        <el-button type="primary" plain icon="el-icon-plus" @click="addTextDialogOpen()">添加课文</el-button>
        <el-button type="primary" plain icon="el-icon-plus" @click="addExamDialogOpen()">添加练习</el-button>
      </div>

      <dy-table v-if="chapterDialog" ref="textTable" tableHeight="300" style="margin-top: 12px;" :columns="textColumns"
        :table-data="textList" :isShowPager="false" element-loading-text="加载中" rowKeyName="uKey"
        dragClassName="drag-class">
      </dy-table>

      <dy-table v-if="chapterDialog" ref="examTable" style="margin-top: 12px;" :columns="examColumns"
        :table-data="examList" :isShowPager="false" element-loading-text="加载中" rowKeyName="uKey">
      </dy-table>

      <div class="box box-align-center box-pack-end mt-btns" style="margin-top: 12px;margin-right: 30px;">
        <el-button type="primary" plain @click="chapterSave()">保存</el-button>
        <el-button type="danger" plain @click="() => chapterDialog = false">取消</el-button>
      </div>
    </el-dialog>

    <el-dialog title="添加课文" :visible.sync="addTextDialog" width="80%" :close-on-click-modal="false">
      <el-row>
        <el-col :span="8">
          <span>课文名称：</span>
          <el-input v-model="addTextName" style="width: 150px;" placeholder="请输入文章名称" clearable></el-input>
        </el-col>
        <el-col :span="8">
          <span>课文分类：</span>
          <el-cascader v-model="addTextCategory" placeholder="请选择" el-cascader :props="{ expandTrigger: 'hover' }"
            clearable></el-cascader>
        </el-col>

        <el-col :span="8">
          <div class="box box-align-center box-pack-end mt-btns">
            <el-button type="primary" icon="el-icon-search" @click="addTextSearch()">搜索</el-button>
            <el-button plain icon="el-icon-refresh" @click="addTextSearch('refresh')">重置</el-button>
          </div>
        </el-col>
      </el-row>

      <dy-table ref="addTextTable" tableHeight="300" style="margin-top: 12px;" :columns="addTextColumns"
        :table-data="addTextList" v-loading="addLoading" :total="addTextTotal" :page-num="addTextPage"
        :page-size="addTextPageSize" @current-change="addTextPageChange" element-loading-text="加载中"
        @selection-change="addTextSelChange" rowKeyName="textId">
      </dy-table>
      <div class="box box-align-center box-pack-end mt-btns" style="margin-top: 12px; margin-right: 30px;">
        <el-button type="primary" plain @click="textAdd()">保存</el-button>
        <el-button type="primary" plain @click="() => addTextDialog = false">关闭</el-button>
      </div>
    </el-dialog>


    <el-dialog title="添加练习" :visible.sync="addExamDialog" width="80%" :close-on-click-modal="false">
      <el-form>
        <el-row>
          <el-col :span="10">
            <el-form-item label="练习名称：">
              <el-input v-model="addExamName" style="width: 200px" placeholder="请输入试卷名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="练习分类：">
              <el-select v-model="addExamCategory" placeholder="请选择试卷分类" multiple>
                <el-option v-for="item in courseOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <div class="">
              <el-button type="primary" @click="addExamSearch()"> <i class="el-icon-search"
                  style="margin-right: 5px"></i>查询
              </el-button>
              <el-button @click="addExamSearch('refresh')"> <i class="el-icon-refresh" style="margin-right: 5px"></i>重置
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <dy-table ref="addExamTable" tableHeight="300" style="margin-top: 12px;" :columns="addExamColumns"
        :table-data="addExamList" v-loading="addLoading" :total="addExamTotal" :page-num="addExamPage"
        :page-size="addExamPageSize" @current-change="addExamPageChange" element-loading-text="加载中"
        @selection-change="addExamSelChange" rowKeyName="textId">
      </dy-table>
      <div class="box box-align-center box-pack-end mt-btns" style="margin-top: 12px; margin-right: 30px">
        <el-button type="primary" plain @click="examAdd()">保存</el-button>
        <el-button type="danger" plain @click="() => addExamDialog = false">取消</el-button>
      </div>
    </el-dialog>

    <el-dialog title="课程预览" :visible.sync="previewDialog" width="80%" :close-on-click-modal="false">
      <div v-if="previewDialog" class="img-qrcode">
        <vue-qr :text="qrText" :size="200"></vue-qr>
      </div>
      <div class="qr-pop">请使用智谷APP扫码查看课程内容</div>
      <div class="box box-align-center box-pack-end mt-btns" style="margin-top: 12px; margin-right: 30px;">
        <el-button v-if="course.examineStatus == 1" type="primary" plain @click="previewPass()">审核通过</el-button>
        <el-button v-if="course.examineStatus == 1" type="primary" plain
          @click="previewRejectDialogOpen()">审核失败</el-button>
        <el-button type="danger" plain @click="() => previewDialog = false">取消</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="previewRejectDialog" width="80%" :close-on-click-modal="false">
      <el-form>
        <el-form-item label="反馈信息：">
          <el-input style="width: 500px;" :rows="4" type="textarea" v-model="rejectMsg"
            placeholder="请输入反馈信息"></el-input>
        </el-form-item>
      </el-form>
      <div class="box box-align-center box-pack-end mt-btns" style="margin-top: 12px; margin-right: 30px;">
        <el-button type="primary" plain @click="previewPass('reject')">发送</el-button>
        <el-button type="danger" plain @click="() => previewRejectDialog = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import DyTable from '@/components/common/dytable'

import { generateUniqueString } from '@/utils/utils';

import { addChapterText, getTextList, selectChapterInfo, courseExamine, getCourseExamList } from '@/api/index2';

import VueQr from 'vue-qr'
import host from '@/api/index';
export default {
  name: "studyContent",
  components: {
    DyTable,
    VueQr
  },
  props: {},

  computed: {
    addIndex() {
      return (index) => {
        return (this.addTextPage - 1) * this.addTextPageSize + index + 1;
      };
    },
    uploadImg() {
      return host.uploadImgUrl;
    },
    headers() {
      return {
        'bg-token': localStorage.getItem('token'), // 直接从本地获取token就行
      };
    },
  },
  data() {
    return {
      course: {},
      courseCategory: [],
      courseOptions: [],

      chapterEditUKey: '',


      chapterListDialog: false,
      chapterListLoading: false,
      chapterListColumns: [],
      chapterList: [],

      // ---单元信息Dialog---
      chapterInfoDialog: false,
      chapter: {
        chapterName: '',
      },

      // ---单元内容Dialog---
      chapterDialog: false,

      textColumns: [],
      textList: [],
      examList: [],
      examColumns: [],

      addLoading: false,

      // ---添加课文Dialog---
      addTextDialog: false,

      addTextCategory: '',
      addTextName: '',
      addTextSearchForm: {},
      addTextSelList: [],

      addTextSelId: [],

      addTextColumns: [],
      addTextList: [],
      addTextTotal: 0,
      addTextPage: 1,
      addTextPageSize: 10,

      // ---添加练习Dialog---
      addExamDialog: false,

      addExamCategory: '',
      addExamName: '',
      addExamSearchForm: {},
      addExamSelList: [],

      addExamColumns: [],
      addExamList: [],
      addExamTotal: 0,
      addExamPage: 1,
      addExamPageSize: 10,

      infoRules: {
        chapterName: [
          { required: true, message: '请输入单元名称', trigger: 'blur' },
          { required: true, message: '请输入单元名称', trigger: 'change' },
        ]
      },

      previewDialog: false,
      qrText: '',
      previewRejectDialog: false,
      rejectMsg: '',

      pageChange: false,
      isSetSelect: false,

    };
  },
  mounted() {

    this.getCourseCategory();

    this.chapterListColumns = [
      {
        type: 'drag',
        render: () => {
          return (
            <i class='el-icon-rank drag-class'></i>
          );
        }
      },
      {
        key: 'chapterName',
        title: '单元名称'
      },
      {
        key: '',
        title: '操作',
        width: 300,
        render: ({ row }) => {
          return (
            <div>
              <el-link type="primary" onClick={() => this.chapterInfoDialogOpen(row)}>编辑</el-link>
              <el-link type="primary" style="margin-left:12px" onClick={() => this.chapterDialogOpen(row)}>单元内容</el-link>
              <el-link type="danger" style="margin-left:12px" onClick={() => this.contDel(row)}>删除</el-link>
            </div>
          );
        }
      },
    ];

    this.textColumns = [
      {
        type: "drag",
        render: () => {
          return (
            <i class="el-icon-rank drag-class"></i>
          );
        }
      },
      {
        type: 'index',
        title: '序号'
      },
      {
        key: 'textId',
        title: '课文ID'
      },
      {
        key: 'textName',
        title: '课文名称'
      },
      {
        key: 'categoryName',
        title: '课文分类'
      },
      {
        key: '',
        title: '操作',
        width: 300,
        render: ({ row }) => {
          return (
            <div>
              <el-link type="danger" style="margin-left:12px" onClick={() => this.textDel(row)}>删除</el-link>
            </div>
          );
        }
      },
    ];

    this.addTextColumns = [
      {
        type: 'selection',
        width: 55,
      },
      {
        type: 'index',
        title: '序号',
        index: this.addIndex
      },
      {
        key: 'textId',
        title: '课文ID'
      },
      {
        key: 'textName',
        title: '课文名称'
      },
      {
        key: 'categoryName',
        title: '课文分类'
      },
    ];

    this.examColumns = [
      {
        key: 'textId',
        title: '练习Id',
      },
      {
        key: 'textName',
        title: '练习名称',
      },
      {
        key: 'categoryName',
        title: '练习分类',
      },
      {
        key: 'bgUserName',
        title: '操作人',
      },
      {
        key: 'updateDate',
        title: '最后更新时间',
      },
      {
        key: '',
        title: '操作',
        width: 300,
        render: ({ row }) => {
          return (
            <div>
              <el-link type='danger' style='margin-left:12px' onClick={() => this.examDel(row)}>删除</el-link>
            </div>
          );
        },
      },
    ];

    this.addExamColumns = [
      {
        type: 'selection',
        width: 55,
      },
      {
        key: 'textName',
        title: '练习名称',
      },
      {
        key: 'categoryName',
        title: '练习分类',
      },
      {
        key: 'bgUserName',
        title: '操作人',
      },
      {
        key: 'updateDate',
        title: '最后更新时间',
      }
    ];

  },
  methods: {

    async getCourseCategory() {
      this.courseCategory = await this.$store.dispatch('category/getCourseCategory');
    },

    chapterListDialogOpen(row) {
      this.course = row
      this.chapterListDialog = true;
      this.getChapterList();
    },

    getChapterList() {
      this.chapterListLoading = true;
      let param = {
        courseId: this.course.id,
      };
      selectChapterInfo(param).then((res) => {
        if (res.result == 1) {
          this.chapterList = res.data;
          console.log('res.data.1111 :>> ', this.chapterList);
          this.chapterList.forEach(c => {
            c.uKey = generateUniqueString();
            c.chapterTextList = [];
            c.chapterExamList = [];
            for (let ct of c.chapterText) {
              ct.uKey = generateUniqueString();
              ct.textType = ct.type;
              delete ct['type'];

              if (ct.textType == 1 || ct.textType == 2) {
                c.chapterTextList.push(ct)
              } else if (ct.textType == 3) {
                c.chapterExamList.push(ct)
              }
            }

          });

        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'error'
          });
        }
        this.chapterListLoading = false;
      });
    },

    chapterInfoDialogOpen(row) {
      if (row && row.uKey) {
        this.chapterEditUKey = row.uKey;
        this.chapter = { ...row };
      } else {
        this.chapterEditUKey = "";
        this.chapter = {
          chapterName: ""
        }
      }

      this.chapterInfoDialog = true;
    },

    chapterInfoSave() {
      this.$refs.chapterInfoForm.validate((valid) => {
        if (valid) {
          let msg = "操作成功"
          let chapterTable = this.$refs.chapterTable.getTableData();
          if (this.chapterEditUKey == "") {
            chapterTable.push({
              ...this.chapter,
              uKey: generateUniqueString(),
              chapterTextList: [],
              chapterExamList: [],
            });
            this.$set(this, 'chapterList', chapterTable)
            msg = "添加成功"
          } else {
            let index = chapterTable.findIndex(item =>
              item.uKey === this.chapter.uKey
            );
            chapterTable[index] = { ...this.chapter };
            this.$set(this, "chapterList", [...chapterTable])
            this.chapterEditUKey = "";
          }
          this.$message({
            showClose: true,
            message: msg,
            type: 'success'
          });
          this.chapterInfoDialog = false;
        } else {
          return false;
        }
      });
    },

    chapterListSave() {
      let chapterTable = this.$refs.chapterTable.getTableData();
      let courseChapters = [];
      for (let i = 0; i < chapterTable.length; i++) {
        let c = chapterTable[i];
        let cc = {
          courseId: this.course.id,
          courseType: this.course.type || 1,
          chapterName: c.chapterName,
          chapterOrder: i + 1,
          chapterText: [],
        }
        let pre = [
          ...c.chapterTextList,
          ...c.chapterExamList,
        ]
        for (let ii = 0; ii < pre.length; ii++) {
          let t = pre[ii]
          let tt = {
            courseId: this.course.id,
            textId: t.textId,
            textOrder: ii + 1,
            textName: t.textName,
            type: t.textType
          }
          cc.chapterText.push(tt);
        }
        courseChapters.push(cc)
      }

      this.chapterListLoading = true;
      let param = {
        id: this.course.id,
        type: this.course.type || 1,
        courseChapters: courseChapters
      };

      addChapterText(param).then((res) => {
        if (res.result == 1) {
          this.$message({
            showClose: true,
            message: "保存成功",
            type: 'success'
          });
          this.addTextDialog = false;
          this.addExamDialog = false;
          this.chapterListDialog = false;
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'error'
          });
          this.addTextDialog = false;
          this.addExamDialog = false;
          this.chapterListDialog = false;
        }
        this.chapterListLoading = false;

      });
    },

    chapterDialogOpen(row) {
      this.chapter = { ...row };
      this.$set(this, 'textList', [...this.chapter.chapterTextList])
      this.$set(this, 'examList', [...this.chapter.chapterExamList])
      this.$nextTick(() => {
        this.$forceUpdate()
      })

      console.log('this.chapter :>> ', this.chapter);
      this.chapterDialog = true;
    },

    chapterSave() {
      this.chapterList = this.$refs.chapterTable.getTableData();
      let textTable = this.$refs.textTable.getTableData()
      let examTable = this.$refs.examTable.getTableData()
      let index = this.chapterList.findIndex(item =>
        item.uKey === this.chapter.uKey
      );
      this.$set(this.chapterList[index], 'chapterTextList', textTable);
      this.$set(this.chapterList[index], 'chapterExamList', examTable);
      this.$message({
        showClose: true,
        message: "保存成功",
        type: 'success'
      });
      this.chapterDialog = false;
    },


    addTextDialogOpen() {
      this.addTextPage = 1;
      this.addTextSelList = JSON.parse(JSON.stringify(this.textList));
      this.addTextSelId = this.addTextSelList.map((e) => {
        return e.textId;
      });
      this.getAddTextList();
      this.addTextDialog = true;
    },

    // 分页
    addTextPageChange(val) {

      this.addTextPage = val;
      this.getAddTextList();
    },

    addTextSearch(msg) {
      this.addTextPage = 1;
      if (msg == "refresh") {
        this.addTextName = null;
        this.addTextCategory = null;
        this.addTextSearchForm = {};
      }
      this.addTextSearchForm = {
        textName: this.addTextName,
        categoryId: this.addTextCategory ? this.addTextCategory[this.addTextCategory.length - 1] : '',
      }
      this.getAddTextList()
    },

    getAddTextList() {
      this.addLoading = true;
      let param = {
        page: this.addTextPage,
        pageSize: this.addTextPageSize,
        ...this.addTextSearchForm
      };
      getTextList(param).then((res) => {
        if (res.result == 1) {
          this.addTextTotal = res.data.total;
          console.log('res :>> ', res);
          // this.addTextPage = res.data.pageNum;
          this.addTextList = res.data.list;

          for (let a of this.addTextList) {
            a.textId = a.id;
            delete a['id']
          }

          if (this.isSetSelect) {
            this.pageChange = true;
          }
          this.$nextTick(() => {
            this.setTextSel();
          });

          this.addLoading = false;
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'error'
          });
        }
      });
    },

    setTextSel() {
      this.$refs.addTextTable.$refs.ElTable.clearSelection();
      let sel = this.addTextList.filter((item) => this.addTextSelId.includes(item.textId));
      this.$nextTick(() => {
        sel.forEach((e) => {
          this.$refs.addTextTable.$refs.ElTable.toggleRowSelection(e, true);
        });
      });

    },

    addTextSelChange(val) {
      if (this.pageChange) {
        this.pageChange = false;
        return;
      }
      let pageId = this.addTextList.map((e) => {
        return e.textId;
      });
      let selId = val.map((e) => {
        return e.textId;
      });

      let delId = pageId.filter((textId) => !selId.includes(textId));



      this.addTextSelId = [...new Set([...this.addTextSelId, ...pageId].filter((id) => !delId.includes(id)))];
      this.addTextSelList = [...this.addTextSelList, ...val];
      this.addTextSelList = Array.from(new Map(this.addTextSelList.map((item) => [item.textId, item])).values());
      this.addTextSelList = this.addTextSelList.filter((e) => !delId.includes(e.textId));
      this.isSetSelect = true;

    },





    textAdd(row) {
      for (let e of this.addTextSelList) {
        e.uKey = generateUniqueString()
      }
      this.$set(this, "textList", [...this.addTextSelList])
      this.addTextDialog = false;
      this.$message({
        showClose: true,
        message: "添加成功",
        type: 'success'
      });
    },

    textDel(row) {
      let textTable = this.$refs.textTable.getTableData();
      let index = textTable.findIndex(item =>
        item.uKey === row.uKey
      );
      textTable.splice(index, 1);
      this.$set(this, 'textList', [...textTable])
    },


    addExamDialogOpen() {
      if (this.examList.length > 0) {
        this.$message({
          showClose: true,
          message: "已配置一个练习，不可配置多个练习，若更改练习请先删除原有练习",
          type: 'error'
        })
        return
      }
      this.addExamPage = 1;
      this.getAddExamList();
      this.addExamSelList = [];
      this.addExamDialog = true;
    },

    // 分页
    addExamPageChange(val) {
      this.addExamPage = val;
      this.getAddExamList();
    },

    addExamSearch(msg) {
      this.addExamPage = 1
      if (msg == "refresh") {
        this.addExamName = null;
        this.addExamCategory = null;
        this.addExamSearchForm = {};
      }
      this.addExamSearchForm = {
        name: this.addExamName,
        categoryId: this.addExamCategory ? this.addExamCategory[this.addExamCategory.length - 1] : '',
      }
      this.getAddExamList()
    },

    getAddExamList() {
      this.addLoading = true;
      let param = {
        type: 1,
        page: this.addExamPage,
        pageSize: this.addExamPageSize,

        ...this.addExamSearchForm

      };

      getCourseExamList(param).then((res) => {

        if (res.result == 1) {

          this.addExamTotal = res.data.total;
          this.addExamPage = res.data.pageNum;
          this.addExamList = res.data.list;

          for (let a of this.addExamList) {
            a.textName = a.name
            a.textId = a.id;
            a.textType = 3;
            delete a['id']
          }
          let selIdList = []
          for (let t of this.examList) {
            selIdList.push(t.textId)
          }
          this.$refs.addExamTable.$refs.ElTable.clearSelection();
          let sel = this.addExamList.filter(item => selIdList.includes(item.textId));
          this.$nextTick(() => {
            sel.forEach(e => {
              this.$refs.addExamTable.$refs.ElTable.toggleRowSelection(e, true);
            });
          })

          this.addLoading = false;
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'error'
          });
        }

      });
    },

    addExamSelChange(val) {
      if (val.length > 1) {
        this.$refs.addExamTable.$refs.ElTable.clearSelection();
        this.$refs.addExamTable.$refs.ElTable.toggleRowSelection(val[val.length - 1]);
        this.addExamSelList = [val[val.length - 1]];
      } else {
        this.addExamSelList = val;
      }
    },

    examAdd(row) {
      for (let e of this.addExamSelList) {
        e.uKey = generateUniqueString()
      }
      this.$set(this, "examList", [...this.addExamSelList])
      this.addExamDialog = false;
      this.$message({
        showClose: true,
        message: "添加成功",
        type: 'success'
      });
    },

    examDel(row) {
      let examTable = this.$refs.examTable.getTableData();
      let index = examTable.findIndex(item =>
        item.uKey === row.uKey
      );
      examTable.splice(index, 1);
      this.$set(this, 'examList', [...examTable])
    },

    contDel(row) {
      let chapterTable = this.$refs.chapterTable.getTableData();
      let index = chapterTable.findIndex(item =>
        item.uKey === row.uKey
      );
      chapterTable.splice(index, 1);
      this.$set(this, "chapterList", [...chapterTable])
    },

    previewDialogOpen(row) {
      this.course = row;
      let jumpStr = JSON.stringify({
        from: "preview"
      })
      this.qrText = `{"jumpType":"5","commonId":"${row.id}","jumpStr":${jumpStr}}`
      this.previewDialog = true;
    },

    previewPass(msg) {
      let param = {
        id: this.course.id,
        examineStatus: msg == 'reject' ? 3 : 2,
      };
      if (msg == 'reject') {
        param.feedback = this.rejectMsg;
      }
      courseExamine(param).then((res) => {
        this.$message({
          showClose: true,
          message: '操作成功',
          type: 'success',
        });
        this.previewRejectDialog = false;
        this.previewDialog = false;
        this.$parent.getList();
      });
    },

    previewRejectDialogOpen() {
      this.rejectMsg = ""
      this.previewRejectDialog = true;
    },
  }
};
</script>
<style scoped>
/* 图片容器居中显示 */
.image-container {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  height: 180px;
  overflow: hidden;
}

.uploaded-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 4px;
}

.img-qrcode {
  /* border: 1px solid green; */
  width: 200px;
  height: 200px;
  margin: 0 auto;
}

.qr-pop {
  text-align: center;
  color: red;
  padding: 30px 0 60px;
}
</style>